import { ApmBase, init } from "@elastic/apm-rum";

let apm: ApmBase | undefined;

export { apm };

/**
 * Без serverUrl/serviceName (локальная сборка, стенд без APM) агент не
 * инициализируем: иначе @elastic/apm-rum пишет в консоль ошибку
 * «RUM agent isn't correctly configured» на каждой загрузке страницы.
 */
export const initApm = ({
  serverUrl,
  serviceName,
}: {
  serverUrl?: string;
  serviceName?: string;
}) => {
  if (!serverUrl || !serviceName) {
    return;
  }

  apm = init({
    serviceName,
    serviceVersion: import.meta.env.VITE_ELASTIC_APM_SERVICE_VERSION,
    environment: import.meta.env.VITE_ELASTIC_APM_ENVIRONMENT,
    // pageLoadTransactionName: window.location.pathname,
    serverUrl,
    active: import.meta.env.VITE_ELASTIC_APM_ACTIVE === "true",
  });
};

export const captureError = (err: any, message: string) => {
  console.error(err, message);

  apm?.captureError(err);
};
